export default class RelativeRelationsFilter {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.textSearch = "";
  }
  fillData(data) {
    this.textSearch = data.textSearch;
  }
}
